// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"12ef20b4","455":"343e816e"}[chunkId] + ".chunk.js";
};